import axios from "axios";

export interface Token {
    value: string; 
    expiresAt: string;
}

export interface Message {
    text: string;
    role: 'user' | 'assistant';
    tool?: boolean;
}
interface ChatRequest {
    messages: Message[];
    text: string;
    serviceType: string;
    promptFields: Record<string, string>;
}

interface CallRequest {
    target: string;
    parameters: Record<string, string>;
}

interface CallResponse {
    sid: string;
    status: 'active'|'ended';
}

class _API {
    baseUrl: string;
    token: string;
    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
        this.token = '';
    }

    login = async (username: string, password: string) => (
        await this.post<Token, any>('auth/login', {username, password})
    )

    refreshToken = async (token: string) => (
        await this.post<Token, any>('auth/refresh', token)
    )

    converse = async (params: ChatRequest) => (
        await this.post<Message[], ChatRequest>('converse', params)
    );

    call = async (target: string, parameters: Record<string,string>): Promise<CallResponse> => (
        await this.post<CallResponse, CallRequest>('call', {target, parameters})
    );

    checkCall = async (contactId: string): Promise<CallResponse['status']> => (
        await this.get<CallResponse['status']>(`call?sid=${contactId}`)
    );

    finishCall = async (contactId: string): Promise<Record<string, string>> => (
        await this.delete<Record<string, string>>(`call?sid=${contactId}`)
    );

    getTwilioToken = async (): Promise<string> => (
        await this.post<string, {}>('token', {})
    );

    async get<T>(path: string): Promise<T> {
        return (await axios.get<T>(
            this.baseUrl + path,
            { headers: { Authorization: this.token } }
        )).data;
    }

    async post<T, U = T>(path: string, data: U): Promise<T> {
        return (await axios.post<T>(
            this.baseUrl + path,
            JSON.stringify(data),
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.token
                }
            }
        )).data;
    }

    async delete<T>(path: string): Promise<T> {
        return (await axios.delete<T>(
            this.baseUrl + path,
            { headers: { Authorization: this.token } }
        )).data;
    }
}

export const API = new _API(process.env.REACT_APP_API_ENDPOINT || 'http://localhost:5000/api/web');